import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  rootHeader: {},
  rootResults: {},
  queryField: {
    width: '100%',
    '& .MuiInputBase-input': {
      color: theme.palette.text.primary,
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
    },
  },
  orderOption: {
    color: theme.palette.text.primary,
    backgroundColor: 'black',
  },
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  action: {
    marginBottom: theme.spacing(1),
    '& + &': {
      marginLeft: theme.spacing(1),
    },
  },
  actionIcon: {
    paddingRight: theme.spacing(1),
    height: '100%',
  },
  searchAction: {
    width: '50px',
    height: '100%',
    borderRadius: '80%',
  },
  options: {
    justifySelf: 'end',
    width: '60%',
  },
  boxDownTable: {
    display: 'flex',
    flexDirection: 'row',
  },
  createDialog: {
    maxWidth: '470px',
    maxHeight: '500px',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    boxSizing: 'border-box',
    width: '570px',
    height: '325px',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',

  },
  createDialogDelete: {
    alignItems: 'center',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
  },
  createDialogDownload: {
    maxWidth: '470px',
    maxHeight: '600px',
    alignItems: 'center',
    boxSizing: 'border-box',
    width: '670px',
    height: '450px',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',

  },
  createDialogTitle: {
    align: 'left',
    color: '#24335E',
    fontSize: '24px',
    fontStyle: 'normal',
    lineHeight: '29px',
    marginBottom: '30px',
    marginTop: '10px',
  },
  createDialogOptions: {
    height: '115px',
    width: '510px',
  },
  createDialogButtons: {
    height: '55px',
    width: '240px',
    background: '#24335E',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    textAlign: 'center',
    color: 'white',
  },
  createDialogButtonsDownload: {
    height: '55px',
    width: '240px',
    background: '#24335E',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    textAlign: 'center',
    color: 'white',
    marginLeft: '2%',
  },
  deleteDialogType: {
    align: 'center',
    color: theme.palette.text.primary,
    fontSize: '20px',
    fontStyle: 'normal',
    lineHeight: '29px',
    marginBottom: '12px',
    marginTop: '8px',
  },
  deleteDialogTypeBold: {
    align: 'center',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 'bold',
    lineHeight: '29px',
    marginTop: '10px',
    color: theme.palette.text.primary,
  },
  createDialogTexfield: {
    marginBottom: '5%',
    marginLeft: '7%',
    width: '510px',
  },
  createDialogTexfieldDownload: {
    marginBottom: '6%',
    // marginLeft: '7%',
    width: '510px',
  },
  controlButtons: {
    marginTop: '20px',
  },
  controlReportText: {
    width: '200px',
  },
  massiveReportCard: {
    backgroundColor: '#f5f5f5',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
  },
  massiveReportTitle: {
    marginBottom: '8px',
    fontWeight: 600,
  },
  massiveReportButton: {
    height: '56px',
    fontWeight: 600,
  },
}));

export default useStyles;
